document.addEventListener( 'DOMContentLoaded', function () {
  const palettes = document.querySelectorAll( '.e-div--brand-guide-color-palette-card' );
  console.log( palettes );
  
  palettes.forEach( ( palette ) => {
    const tooltip = document.createElement( 'span' );
    tooltip.className = 'tooltip';
    tooltip.textContent = 'Copy to clipboard';
    palette.appendChild( tooltip );

    const defaultText = 'Copy to clipboard';

    palette.addEventListener( 'click', function () {
      const hexCodeEl = this.querySelector( '.hex-color-code' );
      if ( !hexCodeEl ) return;

      const hexCode = hexCodeEl.textContent.trim();

      function showTooltip( message ) {
        tooltip.textContent = message;
        palette.classList.add( 'show-tooltip' );
        setTimeout( () => {
          tooltip.textContent = defaultText;
          palette.classList.remove( 'show-tooltip' );
        }, 1000 );
      }

      if ( navigator.clipboard && window.isSecureContext ) {
        navigator.clipboard
          .writeText( hexCode )
          .then( () => showTooltip( `Copied! ${hexCode}` ) )
          .catch( ( err ) => {
            console.error(
              'Clipboard API failed, falling back...',
              err
            );
            fallbackCopy( hexCode );
          } );
      } else {
        fallbackCopy( hexCode );
      }

      function fallbackCopy( text ) {
        const tempInput = document.createElement( 'input' );
        document.body.appendChild( tempInput );
        tempInput.value = text;
        tempInput.select();
        try {
          document.execCommand( 'copy' );
          showTooltip( `Copied! ${text}` );
        } catch ( err ) {
          console.error( 'Fallback copy failed:', err );
        }
        document.body.removeChild( tempInput );
      }
    } );
  } );
} );
